<template>
	<LayoutAuth>
		<form class="form form--auth" @submit.prevent="forgotPassword" novalidate>
			<h1 class="h2">Forgot Password</h1>
			<p class="form__subtitle">Enter your email address and we will send you an email with instructions on how to reset your password.</p>

			<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>
			<div class="alert alert--success" v-if="success">We have sent you an email with reset instructions.</div>

			<div class="form__group">
				<input id="email" type="email" name="email"
				       class="form__control"
				       placeholder="Enter your email address here" required
				       v-model="formData.email" v-validate />
				<label for="email" class="form__label">Email Address</label>
				<div class="form__validation">{{ errors.first('email') }}</div>
			</div>

			<div class="form__group form__group--submit">
				<button type="submit" class="btn btn--primary" :disabled="$wait.is('forgotPassword')">Reset password</button>
			</div>
		</form>
	</LayoutAuth>
</template>

<script>
	import API from './../api';
	import SvgIcon from './SvgIcon';
	import ValidationAlert from './ValidationAlert';
	import LayoutAuth from './Layout/LayoutAuth';

	export default {
		components: {
			LayoutAuth,
			ValidationAlert,
			SvgIcon,
		},
		data() {
			return {
				success: false,
				formData: {
					email: '',
				},
			}
		},
		methods: {
			forgotPassword() {
				this.$wait.start('forgotPassword');

				API.forgotPassword(this.formData.email).then(() => {
					this.success = true;
				}).catch(error => {
					API.mapServerValidation(error.response, this.$validator);
				}).finally(() => {
					this.$wait.end('forgotPassword');
				});
			}
		},
	};
</script>
